type FeaturedMediaEntry = {
	isFeatured: boolean;
	publicUrl: string;
	cardUrl?: string;
	emailUrl?: string;
};

/** Featured entry's variant URL (else its original), falling back to the first entry. */
export function featuredMediaUrl(
	media: FeaturedMediaEntry[] | null | undefined,
	field: "cardUrl" | "emailUrl"
): string | undefined {
	const pick = media?.find((entry) => entry.isFeatured) ?? media?.[0];
	return pick?.[field] ?? pick?.publicUrl;
}
